import { ModelLike, JsonApiPayload } from '../interfaces/JsonApiPayload';
import { ParkPayload } from './ParkPayload';
import { SiteTypePayload } from './SiteTypePayload';

export class SitePayload extends JsonApiPayload {
  id: string;
  label: string;
  siteTypeId: string;
  siteTypeLabel: string;
  pmsId: string;
  name: string;
  siteNumber: string;
  code: string;
  status: string;
  siteStatus: string;
  sewer: boolean;
  water: boolean;
  metered: boolean;
  length: number;
  amenities: string;
  description: string;
  extension: string;
  maxOccupants: number;
  interconnecting: boolean;
  active: boolean;
  hasTasks: boolean;
  housekeeping: string;
  housekeepingActions: string[];
  utilities: string;
  utilitiesActions: string[];
  inspection: string;
  inspectionActions: string[];
  action: string;
  taskList: string[];
  lastInspectedBy: string;
  lastInspectedById: string;
  lastInspectedAt: string;
  allowVehicleElectrical: string[];
  allowVehicleLengthRanges: string[];
  allowVehicleSlides: string[];
  allowVehicleVehicleTowing: string[];
  allowVehicleTypes: string[];
  mostRecentReservation: {
    id: string;
    confirmationNumber: string;
    arrivalDate: string;
    departureDate: string;
    status: string;
  };
  createdAt: string;
  updatedAt: string;
  // relationships
  park?: ParkPayload;
  reservations?: any[];
  siteType?: SiteTypePayload;

  static new(model?: ModelLike) {
    return super.fill(new this(), model);
  }

  static getSchema() {
    const result = super._getSchema(this, ['park', 'reservations', 'siteType']);
    return result;
  }
};
